import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";
import { i18n } from "../../translate/i18n";
import geequipImageSvg from "../../assets/add-user-geequip.svg";
import { useHistory } from "react-router-dom";

interface IProps {
  isModalOpen: boolean;
  closeDialog: () => void;
  type: string | null;
}

export const RedirectModal = ({ isModalOpen, closeDialog, type }: IProps) => {
  const history = useHistory();

  return (
    <Dialog
      open={isModalOpen}
      maxWidth='sm'
      fullWidth
      onClose={closeDialog}
    >
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '50%',
          height: '100%'
        }}>
          <Box
            component="img"
            src={geequipImageSvg}
            alt="checklist"
            sx={{
              width: '100%',
              height: 'auto',
              maxWidth: '400px',
              objectFit: 'contain',
              display: 'block'
            }}
          />
        </Box>
        <Typography variant="h6" color="GrayText">{type ? i18n.t(`modalRedirect.title.${type}`) as string : i18n.t(`modalRedirect.title.invalidInvite`) as string}</Typography>
        <Typography variant="body1" color="GrayText">{type ? i18n.t(`modalRedirect.text.${type}`) as string : i18n.t(`modalRedirect.text.invalidInvite`) as string}</Typography>
        <Button onClick={() => history.push('/login')} color="primary" variant="contained">
          {i18n.t(`modalRedirect.button`) as string}
        </Button>
      </DialogContent>
    </Dialog>
  )
}